import React, { memo, useCallback, useMemo } from 'react'
import { Modal, Typography } from '@mui/material'
import tw from 'twin.macro'
import { colors } from 'src/theme'
import UnpaidPayments from 'src/assets/images/unpaid-payments.svg'
import { Button } from 'src/components/shared/Button'
import { useNavigate } from 'react-router-dom'
import { ROUTES } from 'src/constants/routes'
import useCheckPermissions from 'src/hooks/useCheckPermissions'
import { UserPermission } from 'src/constants/user'
import { CancelSmallMinor } from '@shopify/polaris-icons'

interface Props {
  isOpen?: boolean
  onClose(): void
}

const UnpaidPaymentsDetectedModalComponent = ({ isOpen, onClose }: Props) => {
  const navigate = useNavigate()

  const { hasPermission } = useCheckPermissions()

  const container = useMemo(() => document.getElementById('root'), [])

  const navigateToPaymentsPage = useCallback(() => {
    navigate(ROUTES.PAYMENTS_URL)
  }, [navigate])

  return (
    <Modal
      container={container}
      open={Boolean(isOpen)}
      onClose={onClose}
      aria-labelledby="parent-modal-title"
      aria-describedby="parent-modal-description"
      css={tw`flex justify-center items-center backdrop-blur p-4`}
    >
      <div
        data-testid="contractor-details-unpaid-payments-modal"
        css={tw`max-w-[330px] bg-white rounded-2xl`}
      >
        <div css={tw`p-4 pb-6 flex flex-col items-center`}>
          <div css={tw`w-full flex flex-row justify-end`}>
            <Button
              onClick={onClose}
              color="grey"
              size="small"
              leftIcon={<CancelSmallMinor width={20} />}
              data-testid="contractor-details-unpaid-payments-modal-close-btn"
            />
          </div>
          <img css={tw`w-[210px]`} src={UnpaidPayments} />
          <Typography css={tw`text-center`} variant="h4">
            Unpaid Settlements Detected
          </Typography>
          <Typography css={tw`mt-2 text-center`} color={colors.SHADES_GREY_400}>
            This contractor cannot be reassigned or unassigned while they have unpaid settlements
            uploaded. Please clear or resolve all pending settlements before changing assignment.
          </Typography>
        </div>
        {hasPermission(UserPermission.PaymentsView) && (
          <div css={tw`px-4 py-3 border-0 border-t border-solid  border-[#EDEDED]`}>
            <Button
              fullWidth
              onClick={navigateToPaymentsPage}
              color="light"
              size="small"
              data-testid="contractor-details-unpaid-payments-go-to-payments-btn"
            >
              Go to Settlements Page
            </Button>
          </div>
        )}
      </div>
    </Modal>
  )
}

export const UnpaidPaymentsDetectedModal = memo(UnpaidPaymentsDetectedModalComponent)
